
import styled from "styled-components"
import formatConverter from "../../../../helper/formatConverter"
import { formatShipmentDate, getShipmentRouteBounds, normalizeShipmentListItem } from "../../../../helper/shipment/safeShipmentListItem"
import { useEffect} from "react"
import { useDispatch } from "react-redux"
import moment from "moment"
import { showModal, showNestedModal } from "../../../../features/modal/modalSlice"
import { setSelectUserData } from "../../../../features/user/userSlice"
import Button from "../../../shared/button/Btn"
import { useSelector } from "react-redux"
import { getBelgeData, getSingleShipmentLoadItem, setShipmentActionData, setShipmentContainerAndSealData, setShipmentData } from "../../../../features/loadList/loadListSlice"
import { setIsActiveSide, setTopPagesMapTamamlananShipmentItemCurrentLocationData } from "../../../../features/topPagesMap/topPagesMapSlice"
import ShipmentTrackingDetails, { findDetailedRoutePoint, RoutePointOperationInfo, unwrapTrackingCollection } from "../../../shipmentOperation/ShipmentTrackingDetails"
import CopyableShipmentValue from "../../../shipmentOperation/CopyableShipmentValue"
import { wideShipmentCardStyles } from "../../../shipmentOperation/shipmentCardStyles"

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 40px;
    color: ${({theme}) => theme.mainTextColor};
    position: relative;
            .absolute-id{
            position: absolute;
            bottom: 0;
            left: 0;
            border: 1px solid var(--color-main);
            border-radius: 4px;
            border-bottom-left-radius: 10px;
            padding: 3px;
            font-size: 14px;
            width: 70px;
            text-align: center;
            font-weight: var(--font-weight-lg);
            background-color: var(--color-main);
            color:#fff;
        }
    .content-container{
        width: 100%;
        display: flex;
        justify-content: space-between;
        background-color: ${({theme}) => theme.secondaryBgColor};
        border-radius: 10px;
        padding: 20px 30px;
        /* padding-right: 20px; */
        cursor: pointer;
        .main-content{
            /* display: flex;
            justify-content: space-between; */
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            gap: 20px;
            width: 60%;
            .content-column{
                margin-block: 10px;
                .comment-info{
                    font-size: 12px;
                    font-weight: var(--font-weight-md);
                }
                p{
                    margin-bottom: 5px;
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-xl);
                    color: var(--color-main);
                    span{
                        font-size: 14px;
                        font-weight: var(--font-weight-md);
                    }
                }
                .content-item{
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-md);
                    margin-block:7px;
                }
            }
            .roads{
                display: flex;
                flex-direction: column;
                .road-content{
                    display: flex;
                }
            }
            .others{
                width: 50%;
                display: flex;
                flex-direction: column;
            }
        }
        .map-side{
            width: 600px;
            /* margin: 20px; */
            min-height: 300px;
            display: flex;
            flex-direction: column;
            /* border: 1px solid ${({theme}) => theme.mainTextColor}; */
            border-radius: 10px;
            .map-container{
                width: 100%;
                height: 470px;
                border-radius: 10px;
            }
            .btn-container{
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                margin-top: 10px;
                
                button{
                    margin-right: 5px;
                    padding: 10px;
                }
            }
        }
    }
    .info{
        font-weight: var(--font-weight-lg) !important;
    }
    .comment{
        font-weight: var(--font-weight-lg) !important;
        span{
            font-weight: var(--font-weight-md); 
        }
    }
    .btn-outlined{
        border: 1px solid var(--color-main);
        font-weight: var(--font-weight-lg);
        font-size: 12px;
        padding: 4px;
        border-radius: 6px;
        width: max-content;
        height: max-content;
        margin-top: 7px;
    }

    @media (max-width: 1500px){
        .main-content{
            width: 70% !important;
        }
        .map-side {
            width: 350px !important;
            min-height: 200px !important;
            .map-container {
                height: 400px;
            }

            .btn-container {
                gap: 10px;
                button{
                height: 50px;
                }
            }
        }
    }

    @media (max-width: 1150px){
        .main-content{
            width: 100% !important;
        }
    }

    ${wideShipmentCardStyles}
`  

const ItemWideContainer = ({item: sourceItem, activeItemId, setActiveItemId, forwardRef, handleClick, onShowMap}) => {
    const item = normalizeShipmentListItem(sourceItem)
    const { firstRoutePoint, lastRoutePoint } = getShipmentRouteBounds(item.routePoints)
    const dispatch = useDispatch()
    const {topPagesMapAllTamamlananShipmentCurrentLocationList = []} = useSelector(state => state.topPagesMap)
    const singleShipmentLoadItem = useSelector(state => state.loadList.singleShipmentLoadItem)
    const detailedRoutePoints = item.id === activeItemId && singleShipmentLoadItem?.id === item.id
      ? unwrapTrackingCollection(singleShipmentLoadItem.routePoints)
      : []

    useEffect(() => {
        if(activeItemId === item.id){
            handleClick(item.id)
        }
    },[activeItemId])


    const showUserRateModal = (item) => {
        dispatch(setSelectUserData(item))
        dispatch(showNestedModal("surucuProfilDegerlendir"))
    }

    const handleBelgeDataClick = () => {

        const list = item.routePoints.$values.map((item) => {
            return {
                routeType: item.loadOrUnload,
                stateOfRoutePoint: item.stateOfRoutePoint,
                documentOfRoutePoint: item.documentOfRoutePoint,
                order: item.order,
                comment: item.description,
                location: item.location
            }
            }).filter(item =>  item.stateOfRoutePoint !== 0)

        dispatch(getBelgeData(list))
    
        dispatch(showModal("shipmentIrsaliye"))
    }

    const handleMapFocus = () => {

        onShowMap?.()

        window.scrollTo({ top: 0, behavior: 'smooth' });
        dispatch(getSingleShipmentLoadItem(item.id));
        dispatch(setIsActiveSide(true));
        dispatch(setTopPagesMapTamamlananShipmentItemCurrentLocationData(item.id))
    }
    

  return (
    <Container ref={forwardRef} id={item.id} >
            <CopyableShipmentValue className="absolute-id" label="ID" value={item.id} />
        
        <div onClick={() => {window.getSelection().toString().length < 1 && setActiveItemId(activeItemId === item.id ? null : item.id)}} className="content-container" >
            <div className="main-content">
                <div className="roads">
                    {item.routePoints.$values.filter((item)=>item.loadOrUnload === 0 ).map((item,index)=>{
                        const newIndex = index += 1
                        return(
                            <div className="yukleme">
                                <div className="content-column">
                                    <p>{`${newIndex === 1 ? "" : `${newIndex}.` }`} Yükleme <span>({formatShipmentDate(item.loadDate, value => moment(value).format("DD.MM.YYYY"))})</span></p>
                                    <div className="content-item">Yükleme Saati: {item.loadTime}</div>
                                    {/* <div className="content-item">{moment(item.loadDate).format("DD.MM.YYYY")}</div> */}
                                    <div className="content-item">{item.displayName}</div>
                                    <div className="content-item">{item.address}</div>
                                    <div className="content-item comment">Sürücü Yorumu: {item.description ? <span>{item.description}</span> : <span>Yorum yok.</span> }</div>
                                    {item.stateOfRoutePoint === 0 &&
                                        <div className="content-item info">Yüklemeye Başlanmadı</div>
                                    }
                                    {item.stateOfRoutePoint === 1 &&
                                        <div className="content-item info">Yüklemeye Başlandı</div>
                                    }
                                    {item.stateOfRoutePoint === 2 &&
                                        <div className="content-item info">Yükleme Tamamlandı</div>
                                    }
                                    <RoutePointOperationInfo routePoint={findDetailedRoutePoint(item, detailedRoutePoints)} />
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className="roads">
                {item.routePoints.$values.filter((item)=>item.loadOrUnload === 1 ).map((item,index)=>{
                    const newIndex = index += 1
                        return(
                            <div className="bosaltma">
                                <div className="content-column">
                                    <p>{`${newIndex === 1 ? "" : `${newIndex}.` }`} Boşaltma <span>({formatShipmentDate(item.loadDate, value => moment(value).format("DD.MM.YYYY"))})</span> </p>
                                    <div className="content-item">Boşaltma Saati: {item.loadTime}</div>
                                    {/* <div className="content-item">{moment(item.loadDate).format("DD.MM.YYYY")}</div> */}
                                    <div className="content-item">{item.displayName}</div>
                                    <div className="content-item">{item.address}</div>
                                    <div className="content-item comment">Sürücü Yorumu: {item.description ? <span>{item.description}</span> : <span>Yorum yok.</span> }</div>
                                    {item.stateOfRoutePoint === 0 &&
                                        <div className="content-item info">Boşaltmaya Başlanmadı</div>
                                    }
                                    {item.stateOfRoutePoint === 1 &&
                                        <div className="content-item info">Boşaltmaya Başlandı</div>
                                    }
                                    {item.stateOfRoutePoint === 2 &&
                                        <div className="content-item info">Boşaltma Tamamlandı</div>
                                    }
                                    <RoutePointOperationInfo routePoint={findDetailedRoutePoint(item, detailedRoutePoints)} />
                                </div>
                            </div>
                        )
                    })}
                </div> 
                <div className="others">
                    <div className="content-column">
                        <p>Yük</p>
                        <div className="content-item">{firstRoutePoint.displayName}</div>
                        <div className="content-item">{item.waitinLoad.isParsiyel ? "LTL(Parsiyel)" : "FTL(Komple Araç)"} {item.waitinLoad.loadUnit === "BASAR TONAJ" ? "Basar Tonaj": `${item.waitinLoad.loadQuantity} ${item.waitinLoad.loadUnit}`}</div>
                         <CopyableShipmentValue className="copy-field" label="Konteyner No" value={item.containerNumber} />
                    <CopyableShipmentValue className="copy-field" label="Mühür No" value={item.sealNumber} />
                    <CopyableShipmentValue className="copy-field" label="Firma Sevk. No" value={item.companyLoadNumber} />
                    </div>

                    <div onClick={(e) => e.stopPropagation()} className="content-column">
                        <p>Sürücü</p>
                        <div onClick={() => {dispatch(showNestedModal("surucuProfil")); dispatch(setSelectUserData(item?.driverPhoneNumber)) }} className="content-item underline">{item.driverName}</div>
                        <div className="content-item">{item.driverPhoneNumber}</div>
                    </div>

                    <div className="content-column">
                        <p>Araç</p>
                      <div className="content-item">{item.truckPlateNumber} - {item.truckType}</div>
                    <div className="content-item">{item.trailerPlateNumber} - {item.trailerType} </div>
                    </div>

                    <div className="content-column">
                        <p>Diğer Bilgiler</p>
                        <div className="content-item">{item.companyName}</div>

                        <div className="content-item">{lastRoutePoint.routePointPersonPhoneNumber} {lastRoutePoint.routePointPersonName}</div>
                        <div className="content-item">{formatConverter(item.freight, 0)} TL</div>
                        <div className="content-item">Tamamlanma Saati: {formatShipmentDate(lastRoutePoint.routePointEndDate, value => moment(value).format("DD.MM.YYYY HH:mm"))}</div>
                    </div>

                    <div className="content-column">
                        <p>Belgeler</p>
                        <div className="content-item">
                            <div className="content-item btn-outlined" onClick={(e)=> {e.stopPropagation(); handleBelgeDataClick(item)}}>Sevk İrsaliyesi</div>
                            <div className="content-item btn-outlined" onClick={(e)=> {e.stopPropagation(); dispatch(setShipmentData(item)); dispatch(showModal("showMektupShipment"))}}>Taşıma Senedi</div>
                        </div>
                    </div>

                    <div className="content-column">
                        <p>Yorumunuz</p>
                        {
                            item?.truckerUserRate?.$values[0]?.comment?.length > 1 ?
                            <div className="content-item">{item?.truckerUserRate?.$values[0]?.comment}</div> 
                            : 
                            <div className="content-item">
                                <span>Yorum bulunmuyor.</span>
                                <div onClick={()=> showUserRateModal(item)} className="comment btn-outlined">Taşıyıcıyı Değerlendir</div>
                            </div>
                        }
                        {item?.truckerUserRate?.$values[0]?.isApproved === 1 &&
                            <div className="comment-info"><span>(Yorumunuz onaylandı.)</span></div>
                        }
                        {item?.truckerUserRate?.$values[0]?.isApproved === 2 &&
                            <div className="comment-info"><span>(Yorumunuz reddedildi.)</span></div>
                        }
                        {item?.truckerUserRate?.$values[0]?.isApproved === 3 &&
                            <div className="comment-info"><span>(Yorumunuz onay bekliyor.)</span></div>
                        }
                    </div>
                </div>
                {item.id === activeItemId && <ShipmentTrackingDetails className="tracking-history" shipmentId={item.id} />}
                    </div>
                    <div className="wide-actions" onClick={(e) => e.stopPropagation()}>
                        <Button bgColor={"#E85446"} color={"#fff"} width={"230px"} handleClick={() => {
                            dispatch(setShipmentContainerAndSealData({
                                shipmentId: item.id,
                                containerNumber: sourceItem?.containerNumber ?? "",
                                sealNumber: sourceItem?.sealNumber ?? ""
                            }))
                            dispatch(showModal("updateShipmentContainerAndSealNumbers"))
                        }}>Konteyner-Mühür No Güncelle</Button>
                        <Button bgColor={"transparent"} color={"#E85446"} borderColor={"#E85446"} width={"130px"} handleClick={() => { dispatch(setShipmentActionData(sourceItem)); dispatch(showModal("deleteShipmentPermission")); }}>Sevkiyatı Sil</Button>
                        {
                            topPagesMapAllTamamlananShipmentCurrentLocationList.map(item => item.shipmentId).includes(item.id) && 
                            <Button bgColor={"#E85446"} color={"#fff"} width={"220px"} handleClick={handleMapFocus}>Sürücü Konumunu Görüntüle</Button>
                        }
                    </div>
        </div>
    </Container>
  )
}

export default ItemWideContainer
